import React, { useMemo } from "react";
import SettingsComponent from "../Components/SettingsComponent.js";
import styles from "../Styles/Settings.module.css";

import { useCompanyConfig } from "../Commoncontext/CompanyConfigContext";

import IconHome from "../Images/IconHome.js";
import IconBuilding from "../Images/IconBuilding.js";
import IconService from "../Images/IconPartners.js";
import IconUsers from "../Images/IconUsers.js";
import IconCalendar from "../Images/IconCalendar.js";
import IconPortal from "../Images/IconScreen.js";
import IconMeter from "../Images/IconMeter.js";
import IconDocuments from "../Images/IconDocuments.js";
import IconSettings from "../Images/IconSettings.js";
import IconAnnouncements from "../Images/IconAnnouncements.js";
import IconWizard from "../Images/IconWizard.js";

function Settings() {
  const { enabledSettingsItems, loading, error } = useCompanyConfig();

  // ✅ Pidetään lista ennallaan (icon + link + disabled),
  // lisätään vain globaalin configin keyt.
  const settingsItems = [
    {
      key: "companyinfo",
      icon: <IconHome />,
      title: "Yhtiön perustiedot",
      link: "/settings/baseinformation",
      disabled: false,
    },
    {
      key: "usermanagement",
      icon: <IconUsers />,
      title: "Käyttäjähallinta",
      link: "/settings/users",
      disabled: false,
    },
    {
      key: "companyspaces",
      icon: <IconBuilding />,
      title: "Talonyhtiön tilat",
      link: "/building-facilities",
      disabled: true,
    },
    {
      key: "suppliers",
      icon: <IconService />,
      title: "Palvelutoimittajat",
      link: "/settings/users-v3",
      disabled: true,
    },
    {
      key: "portalfunctions",
      icon: <IconPortal />,
      title: "Portaalitoiminnot",
      link: "/settings/portalconfig",
      disabled: false,
    },
    {
      key: "calendars",
      icon: <IconCalendar />,
      title: "Varauskalenterit",
      link: "/settings/calendars-admin",
      disabled: false,
    },
    {
      key: "meters",
      icon: <IconMeter />,
      title: "Mittaritiedot",
      link: "/settings/meters",
      disabled: false,
    },
    {
      key: "communicationsettings",
      icon: <IconAnnouncements />,
      title: "Viestintäasetukset",
      link: "/settings/activitylogs",
      disabled: true,
    },
    {
      key: "aisettings",
      icon: <IconWizard />,
      title: "AI asetukset",
      link: "/settings/activitylogs",
      disabled: true,
    },
    {
      key: "documentsettings",
      icon: <IconDocuments />,
      title: "Dokumenttiasetukset",
      link: "/settings/activitylogs",
      disabled: true,
    },
    {
      key: "actionslog",
      icon: <IconSettings />,
      title: "Toimintoloki",
      link: "/settings/activitylogs",
      disabled: false,
    },
  ];

  /* ============================================================================
     HOOKIT AINA ENNEN RETURNIA
     - Suodatus + järjestys configin mukaan
     - HUOM: jotta status="hidden" voidaan näyttää disabled-tilassa,
       CompanyConfigContextin EI pidä suodattaa hiddeniä pois.
  ============================================================================ */
  const visibleItems = useMemo(() => {
    const cfgItems = Array.isArray(enabledSettingsItems) ? enabledSettingsItems : [];

    // key -> config
    const cfgByKey = new Map();
    cfgItems.forEach((it, idx) => {
      const key = String(it?.key || "").trim();
      if (!key) return;

      cfgByKey.set(key, {
        key,
        defaultLabel: String(it?.defaultLabel || "").trim(),
        defaultOrder: Number.isFinite(it?.defaultOrder)
          ? it.defaultOrder
          : (idx + 1) * 10,
        status: String(it?.status || "published").toLowerCase(), // published | beta | hidden
      });
    });

    // 1) Näytä vain keyt jotka löytyvät configista
    // 2) Otsikko configista jos löytyy
    // 3) Järjestys configin defaultOrderin mukaan
    // 4) status="hidden" => näytetään mutta pakotetaan disabled + ei navigointia
    const out = settingsItems
      .filter((item) => cfgByKey.has(String(item.key || "").trim()))
      .map((item) => {
        const key = String(item.key || "").trim();
        const conf = cfgByKey.get(key);

        const status = conf?.status || "published";
        const forcedDisabled = status === "hidden";

        return {
          ...item,
          title: conf?.defaultLabel ? conf.defaultLabel : item.title,
          order: conf?.defaultOrder ?? 9999,
          status,
          disabled: item.disabled || forcedDisabled,
        };
      })
      .sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999));

    return out;
  }, [enabledSettingsItems]);

  return (
    <div className={styles.container}>
      <div className={styles.pageTitle}>
        <div style={{ marginRight: "16px" }}>
          <IconSettings />
        </div>
        <h2>Asetukset</h2>
      </div>

      {/* Ei muuteta ulkoasua – nämä on “kevyt” lisäinfo */}
      {loading && <div style={{ marginBottom: 12 }}>Ladataan…</div>}
      {error && (
        <div style={{ marginBottom: 12 }}>Asetusten lataus epäonnistui.</div>
      )}

      <div className={styles.grid}>
        {visibleItems.map((item) => (
          <SettingsComponent
            key={item.key}
            icon={item.icon}
            title={item.title}
            // ✅ jos disabled, ei navigoida mihinkään
            link={item.disabled ? "#" : item.link}
            disabled={item.disabled}
          />
        ))}
      </div>
    </div>
  );
}

export default Settings;
